<template>
  <el-dialog :title="title" :visible.sync="open" :before-close="close" :append-to-body="true" width="700px">
    <div>
      <div class="container-message">
        <form-group label="Message" required>
          <template slot="input">
            <textarea name="message" v-model="advice.message[lang]" placeholder="Message" rows="6"></textarea>
          </template>
        </form-group>
      </div>

      <form-group label="Score" required>
        <template slot="input">
          <el-radio-group v-model="advice.score">
            <el-radio-button label="-2">Slackness (-30%)</el-radio-button>
            <el-radio-button label="-1">Downturn (-20%)</el-radio-button>
            <el-radio-button label="0">Equal</el-radio-button>
            <el-radio-button label="1">Good (+5%)</el-radio-button>
            <el-radio-button label="2">Very Good (+10%)</el-radio-button>
          </el-radio-group>
        </template>
      </form-group>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close" plain >{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save" :loading="isSaving">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import formGroup from '@/components/layouts/form-group.vue'

export default {
  name: 'advice-form',
  props: {
    id: {
      type: String,
      required: false
    },
    alias: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    open: {
      type: Boolean,
      required: true
    }
  },

  components: { formGroup },

  data () {
    return {
      advice: {},
      isSaving: false
    }
  },

  computed: {
    ...mapGetters('advices', {
      getById: 'getById'
    }),
    ...mapGetters('account', {
      lang: 'defaultLang',
      site: 'currentSite'
    }),

    title () {
      if (this.id) {
        return 'Edit a message'
      } else {
        return 'Create a message'
      }
    }
  },
  methods: {
    ...mapActions('advices', ['addAdvice', 'updateAdvice']),
    save () {
      this.isSaving = true
      if (!this.id) {
        this.addAdvice({advice: this.advice}).then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.message.addMessage'),
            type: 'success'
          })
          this.close()
        }).catch((response) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('api.' + response.code + '.message')
          })
          this.isSaving = false
        })
      } else {
        this.updateAdvice({advice: this.advice}).then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.message.editMessage'),
            type: 'success'
          })
          this.close()
        }).catch((response) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('api.' + response.code + '.message')
          })
          this.isSaving = false
        })
      }
    },

    close () {
      this.isSaving = false
      this.$emit('close')
    }
  },
  created () {
    if (this.id) {
      this.advice = this._.cloneDeep(this.getById(this.id), false)
    } else {
      this.advice = {
        message: {},
        event: this.alias,
        type: this.type,
        score: 0
      }
    }
  }
}

</script>

<style lang="scss" scoped>
    textarea {
        background: white;
        border:1px solid #dadada;
        border-radius: 4px;
        width: 100%;
        padding: 8px;
        color: #565656;
    }
</style>



// WEBPACK FOOTER //
// src/components/advice/advice-form.vue